// Pages anyone can open without signing in: the routes under routes/_unauthenticated, plus the root.
// Every other page shows account or investment details, where the Meta Pixel and HubSpot's tracker
// do not run (Legal item e).
export const PUBLIC_PATHS = [
  '/',
  '/login',
  '/login/confim',
  '/login/challenge-password',
  '/signup',
  '/signup/confirm',
  '/forgot-password',
  '/forgot-password/confirm',
  '/additional-uploads-investor',
  '/affordability-calculator',
  '/cost-calculator',
  '/investor-registration',
  '/subscription-form',
];

export function isPublicPath(pathname: string): boolean {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return PUBLIC_PATHS.includes(path);
}
